<template>
  <div class="bigEvents">
    <common-layout>
      <div slot="header">
        <h3>大事记</h3>
      </div>
      <div slot="container">
        <div class="bigEvents-search">
          <el-button
            type="success"
            icon="el-icon-plus"
            @click="addEvent"
            style="background: #623AA2; border: none;"
          >新增</el-button>
          <el-button type="danger" icon="el-icon-delete" @click="deleteAll">批量删除</el-button>
          <el-date-picker
            class="date-picker"
            v-model="time"
            type="daterange"
            @change="search(true)"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          ></el-date-picker>
     
        </div>
        <div class="bigEvents-table">
          <el-table
            ref="multipleTable"
            :data="tableData"
            style="width: 100%"
            :header-cell-style="{ background: '#E5F3FE', color: '#623AA2' }"
            class="table"
            @selection-change="selectionChange"
          >
            <el-table-column type="selection" width="55"></el-table-column>

            <el-table-column type="index" width="150" label="序号" align="center">
              <template slot-scope="scope">
                <span>{{ scope.$index + (current_page - 1) * per_page + 1 }}</span>
              </template>
            </el-table-column>

            <el-table-column label="内容" align="center">
              <template slot-scope="scope">
                <div slot="reference" class="name-wrapper">
                  <p size="medium">{{ scope.row.content }}</p>
                </div>
              </template>
            </el-table-column>

            <el-table-column label="发布时间" align="center">
              <template slot-scope="scope">
                <div slot="reference" class="name-wrapper">
                  <span size="medium">{{ scope.row.date_time }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column align="center" label="操作">
              <template slot-scope="scope">
                <el-button
                  class="mini_btn"
                  size="mini"
                  type="primary"
                  @click="handleEdit(scope.$index, scope.row)"
                >编辑</el-button>
                <el-button
                  class="mini_btn"
                  size="mini"
                  type="danger"
                  @click="handleDelete(scope.$index, scope.row)"
                >删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page.sync="current_page"
          :page-size="per_page"
          layout="total,prev, pager, next"
          :total="total"
          style="text-align:left;margin:20px 0"
        ></el-pagination>
      </div>
    </common-layout>
    <el-dialog :title="Title" :visible.sync="dialogFormVisible" :close-on-click-modal="false">
      <el-form
        :model="ruleForm"
        ref="ruleForm"
        :rules="rules"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="日期" prop="date_time">
          <el-date-picker
            v-model="ruleForm.date_time"
            type="date"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            placeholder="选择日期"
            style="width:100%"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="内容" prop="content">
          <el-input type="textarea" v-model="ruleForm.content" placeholder="请输入内容" :rows="4"></el-input>
        </el-form-item>
        <!-- <el-form-item label="链接" prop="link">
					<el-input v-model="ruleForm.link" placeholder="请输入链接"></el-input>
				</el-form-item>
        -->
        <div style="text-align:right;margin-top:10px">
          <el-button type="primary" @click="submitForm('ruleForm')">提交</el-button>
          <el-button @click="closeForm('ruleForm')">取消</el-button>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import CommonLayout from "../../components/common-layout.vue";
export default {
  components: {
    CommonLayout,
  },
  data() {
    return {
      total: 10,
      per_page: 10,
      current_page: 1,
      searchValue: "",
      dialogFormVisible: false,
      Title: "",
      time: [],
      start_time: "",
      end_time: "",
      tableData: [],
      deleteRow: "",
      ruleForm: {
        date_time: "",
        content: "",
        link: "",
      },
      rules: {
        content: [
          {
            required: true,
            message: "请输入内容",
            trigger: "blur",
          },
        ],
        date_time: [
          {
            required: true,
            message: "请选择时间",
            trigger: "change",
          },
        ],
      },
    };
  },
  created() {
    this.getData("Big");
  },
  methods: {
    getData(url, pam) {
      let params = {};
      if(url.indexOf('?') > -1){
        let urlParams = url.split('?')[1]?.split('&')
        urlParams.forEach(item => {
          params[item.split('=')[0]] = item.split('=')[1]
        })
      }

      this.http.post(`${urlConfig.devUrl}apij2/admin-api/trade/big/page`, params).then((res) => {
        if (res.code == 0) {
          this.tableData = res.data.data;
          this.total = res.data.total;
          this.per_page = res.data.per_page;
          this.current_page = res.data.current_page;
        }
      });
    },
    //新增
    addEvent() {
      this.dialogFormVisible = true;
      this.Title = "新建";
      this.ruleForm = {
        date_time: "",
        content: "",
        link: "",
      };
    },
    //编辑
    handleEdit(index, row) {
      this.dialogFormVisible = true;
      this.Title = "编辑";
      this.ruleForm = JSON.parse(JSON.stringify(row));
    },
    //搜索
    search(flag = false) {
      this.start_time = "";
      this.end_time = "";
      if (flag && this.time) {
        this.start_time = this.time[0];
        this.end_time = this.time[1];
		    this.current_page=1;
	  }
	    this.getData(`Big?start_time=${this.start_time}&end_time=${this.end_time}&page=${this.current_page}`);
    },
    //提交
    submitForm(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          let obj = JSON.parse(JSON.stringify(this.ruleForm));
          if (this.Title == "新建") {
            this.http.post(`${urlConfig.devUrl}apij2/admin-api/trade/big/create`, obj).then((res) => {
              if (res.code == 0) {
                this.getData("Big");
                this.$message({
                  type: "success",
                  message: "新增成功",
                });
                this.dialogFormVisible = false;
                this.$refs[name].resetFields();
              }
            });
          }
          if (this.Title == "编辑") {
            // delete obj.id;
            this.http.post(`${urlConfig.devUrl}apij2/admin-api/trade/big/update`, obj).then((res) => {
              if (res.code == 0) {
                this.getData("Big");
                this.$message({
                  type: "success",
                  message: "编辑成功",
                });
                this.dialogFormVisible = false;
                this.$refs[name].resetFields();
              }
            });
          }
        } else {
          return false;
        }
      });
    },
    //取消
    closeForm(name) {
      this.dialogFormVisible = false;
      this.$refs[name].resetFields();
    },
    //翻页
    handleCurrentChange(val) {
		this.current_page
		this.search()
	},
    //选择
    selectionChange(selection) {
      this.deleteRow = "";
      if (selection.length != 0) {
        let arr = [];
        selection.forEach((item) => {
          arr.push(item.id);
        });
        this.deleteRow = arr.join(",");
      }
    },
    //删除
    handleDelete(index, row) {
      this.$confirm("此操作将永久删除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          this.http.request(`${urlConfig.devUrl}apij2/admin-api/trade/big/delete?id=` + row.id, "", "delete").then((res) => {
            if (res.code == 0) {
              this.getData(`Big`);
              this.$message({
                type: "success",
                message: "删除成功",
              });
            } else {
              this.$message({
                message: "失败！",
                type: "error",
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    //批量删除
    deleteAll() {
      if (this.deleteRow) {
        this.$confirm("此操作将批量删除, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          center: true,
        })
          .then(() => {
            this.http
              .request(`${urlConfig.devUrl}apij2/admin-api/trade/big/batchDelete?ids=` + this.deleteRow, "", "delete")
              .then((res) => {
                if (res.code == 0) {
                  this.getData("Big");
                  this.$message({
                    type: "success",
                    message: "删除成功",
                  });
                } else {
                  this.$message({
                    message: "失败！",
                    type: "error",
                  });
                }
              });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除",
            });
          });
      } else {
        this.$message({
          type: "warning",
          message: "请选择删除的事记",
        });
      }
    },
  },
};
</script>
<style lang="scss">
@include component(bigEvents) {
  height: 100%;
  width: 100%;

  .bigEvents-search {
    width: 100%;
    text-align: left;
    display: flex;
    justify-content: flex-start;

    .el-input {
      width: 400px;
      margin: 0 15px;
    }

    .date-picker {
      margin: 0 15px;

      .el-range-separator {
        width: auto;
      }
    }
  }

  .bigEvents-table {
    width: 100%;
    margin-top: 20px;
    border: 1px solid #eef1f6;

    /deep/ .cell {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    p {
      width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
</style>
